import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-general-seguros',
  templateUrl: './loader-general-seguros.component.html',
  styleUrls: ['./loader-general-seguros.component.scss']
})
export class LoaderGeneralSegurosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
